import { lobToBundleCardInfo, ProductCardInfo } from "../pages/agent-partner-select/agent-partner-select";
import { AgentPartnerBundleCard } from "./agent-partner-bundle-card";

interface AgentBundleSectionProps {
  bundlesData: lobToBundleCardInfo[];
  showBundles: boolean;
  setShowAlert?: (show: boolean) => void;
  setAlertMessage?: (message: { title: string; message: string }) => void;
  waitForUserConfirmation?: (partnerInfo: ProductCardInfo) => Promise<void>;
}

export const AgentBundlesSection: React.FC<AgentBundleSectionProps> = ({
  bundlesData,
  showBundles,
  setShowAlert = () => {},
  setAlertMessage = () => {},
  waitForUserConfirmation = () => Promise.resolve(),
}) => {
  return (
    <div>
      <h2 className="agent-partner-select-products-header">
        Promotional Bundles
      </h2>
      <p className="agent-partner-select-products-sub-header">
        Based on the customer's business, here are some common bundle
        opportunities:
      </p>
      {showBundles && bundlesData && (
        <div>
          {bundlesData
            .filter((product) => product.isEnabled)
            .map((product, index) => (
              <AgentPartnerBundleCard
                key={product.lobName}
                showProducts={true}
                cardInfo={product}
                setShowAlert={setShowAlert}
                setAlertMessage={setAlertMessage}
                waitForUserConfirmation={waitForUserConfirmation}
              />
            ))}
        </div>
      )}
      {!showBundles && (
        <div>
          <AgentPartnerBundleCard showProducts={false} />
        </div>
      )}
    </div>
  );
};
